// extracted by mini-css-extract-plugin
module.exports = {"amount":"BalanceDue_amount__3wLF9","list":"BalanceDue_list__TP8XE","listRow":"BalanceDue_listRow__1hbnl","total":"BalanceDue_total__bu3lp"};